// no imports: bundled into the request processor, which runs on Lambda@Edge

/**
 * Known paid media click IDs grouped by advertising platform source.
 */
export const KNOWN_CLICK_IDS = new Set([
    // Google Ads & DoubleClick
    'gclid',
    'gbraid',
    'wbraid',
    'dclid',
    // Google Merchant Center (Shopping)
    'srsltid',
    // Meta (Facebook / Instagram)
    'fbclid',
    // Microsoft Advertising (Bing)
    'msclkid',
    // TikTok
    'ttclid',
    // Pinterest
    'epik',
    // X (formerly Twitter)
    'twclid',
    // LinkedIn
    'li_fat_id',
    // Snapchat
    'sccid',
    'scid',
    // Yahoo
    'yclid',
    // Reddit
    'rdt_cid'
])

/**
 * Checks if a parameter key is an attribution or campaign parameter (UTM parameter or known click ID).
 *
 * @param {string} key - Query parameter name to check.
 * @returns {boolean} True if the key is a campaign parameter.
 * @example
 * isCampaignParameter('utm_source') // true
 * isCampaignParameter('GCLID') // true
 * isCampaignParameter('color') // false
 */
export const isCampaignParameter = (key) => {
    if (typeof key !== 'string' || !key) {
        return false
    }
    const normalizedKey = key.toLowerCase()
    return normalizedKey.startsWith('utm_') || KNOWN_CLICK_IDS.has(normalizedKey)
}
